import TeacherList from './TeacherList';

export default TeacherList;
